import { LANG } from './config';
import { getMetaOpenGraph, getMetaTwitter } from '~/modules/common/utils/metaUtils';
import i18n from '~/i18n';
const t = i18n.messages[LANG];
const header = {
  default: {
    title: 'Onedio',
    description: t.meta.corporate,
  },
  aboutUs: {
    title: `${t.corporate['about-us']} | Onedio`,
    description: t.meta.corporate,
  },
  contact: {
    title: `${t.corporate.contact} | Onedio`,
    description: t.meta.contact,
  },
  career: {
    title: `${t.meta['career-title']} | Onedio`,
    description: t.meta.career,
  },
  masthead: {
    title: `${t.corporate.masthead} | Onedio`,
    description: t.meta.title,
  },
  cookies: {
    title: `${t.corporate['cookie-policy']} | Onedio`,
    description: t.meta['cookie-policy'],
  },
  privacy: {
    title: `${t.meta['privacy-policy-title']} | Onedio`,
    description: t.meta['privacy-policy'],
  },
  agreement: {
    title: `${t.meta['user-agreement-title']} | Onedio`,
    description: t.meta['user-agreement'],
  },
  principles: {
    title: `${t.corporate['publication-principles']} | Onedio`,
    description: t.meta['publication-principles'],
  },
  rules: {
    title: `${t.corporate['community-rules']} | Onedio`,
    description: t.meta['community-rules'],
  },
};

export default function pageHeader(page = 'default') {
  return {
    title: header[page].title,
    meta: [
      { name: 'description', hid: 'description', content: header[page].description },
      ...getMetaOpenGraph(header[page]),
      ...getMetaTwitter(header[page]),
    ],
  };
}
